// tslint:disable:max-line-length

import React from 'react';

export const ActionDelete = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M6.2,0C5.8,0,5.5,0.3,5.5,0.8V2h-3c-1.1,0-2,0.9-2,2h15c0-1.1-0.9-2-2-2h-3V0.8c0-0.4-0.3-0.8-0.8-0.8H6.2z M6.5,1h3v1h-3V1 z M2.5,5v11h11V5h-2v8.5h-1V5h-2v8.5h-1V5h-2v8.5h-1V5H2.5z" />
    </svg>
  );
};
